import { render } from "./RoomCategoryPanel.vue?vue&type=template&id=58ba200d"
import script from "./RoomCategoryPanel.vue?vue&type=script&lang=js"
export * from "./RoomCategoryPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__